import { Type } from 'class-transformer';
import { BoardApprovalActionsResultDto } from '../../shared-acc-board-approval-module/_models/board-approval-actions-result-dto';

export class BoardApprovalAllowedActionsResultDto {
    allowApprovalWithModification: boolean;

    @Type(() => BoardApprovalActionsResultDto)
    actions: Array<BoardApprovalActionsResultDto>;
}
